import { useLocalStorage } from '@mantine/hooks'
import React, { useEffect, useState } from 'react'
import styled, { keyframes, css } from 'styled-components'
import { COLOR_NAMES } from 'Theme'

// Define a CSS keyframe animation for pulsing
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`

const strokePulse = keyframes`
  0% { stroke: #126554; opacity: 0.2; }
  50% { stroke: ${COLOR_NAMES.PINEY_LAKE}; opacity: 1; }
  100% { stroke: #126554; opacity: 0.2; }
`

const AnimatedIconWrapper = styled.div<{ shouldAnimate: boolean }>`
  display: inline-block;
  transform-origin: center center;
  vertical-align: middle;

  ${({ shouldAnimate }) =>
    shouldAnimate &&
    css`
      animation: ${pulse} 1s ease-in-out 5;
    `}

  svg path {
    ${({ shouldAnimate }) =>
      shouldAnimate &&
      css`
        animation: ${strokePulse} 1s ease-in-out 5;
      `}
  }
`
export const AddToFavoritesDetailHintPopover = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [hasSeenHint, setHasSeenHint] = useLocalStorage({
    key: 'seen-favorite-detail-hint',
    defaultValue: false,
    getInitialValueInEffect: false,
  })

  const [shouldAnimate, setShouldAnimate] = useState(false)

  useEffect(() => {
    if (!hasSeenHint) {
      setShouldAnimate(true)
      setHasSeenHint(true)

      const timeout = setTimeout(() => {
        setShouldAnimate(false)
      }, 5000)

      return () => clearTimeout(timeout)
    }
    return undefined
  }, [hasSeenHint, setHasSeenHint])

  return (
    <AnimatedIconWrapper shouldAnimate={shouldAnimate}>
      {children}
    </AnimatedIconWrapper>
  )
}
